




































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import BTreeselectConfig, {
  TreeselectMethodParams,
  TreeselectModel
} from "@/core/BTreeselectConfig/BTreeselectConfig";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import {
  LOAD_CHILDREN_OPTIONS,
  ASYNC_SEARCH,
  LOAD_ROOT_OPTIONS
} from "@riophae/vue-treeselect";
import BaseEntity from "@/models/base/BaseEntity.model";
import Section from '../../models/section.model';
import ProfileAttribute from '../../models/profileAttribute.model';

@Component({})
export default class BaseTreeSelect extends Vue {
  @Prop() public whereParams!: string;
  @Prop() public whereChildrenParams!: string;
  @Prop() public disableBranchNodes!: boolean;
  @Prop() public value: any;
  @Prop() public placeholder!: string;
  @Prop() public disabled!: boolean;
  @Prop() public multiple!: boolean;

  model = new BTreeselectConfig();
  client!: BaseHttpClient;
  childClient!: BaseHttpClient;
  data: Section[] = [];
  childData: Section[] = [];
  options: TreeselectModel[] | null = null;
  constructor() {
    super();
    this.model.controller = 'Section';
    this.model.value = this.value;
    this.model.whereParams = this.whereParams;
    this.model.whereChildrenParams = this.whereChildrenParams;
    
    this.model.disabled = this.disabled;
    this.model.multiple = this.multiple;
    this.model.disableBranchNodes = this.disableBranchNodes;

    this.model.loadOptions = this.loadOptions;
    this.model.open = this.open;
    this.model.close = this.close;
    this.model.input = this.input;
    this.model.select = this.select;
    this.model.deselect = this.deselect;
    this.model.searchChange = this.searchChange;

    this.client = new BaseHttpClient(this.model.controller);
    this.childClient = new BaseHttpClient('ProfileAttribute');
  }
  getOptions(data: any[]) {
    return data.map((item: any) => {
      var label = item['title'] || item['name'];
      var options = new TreeselectModel(`${item.id}-section`, label);
    options.children = null;
      return options;
    });
  }
   getChildOptions(data: any[], type: 'section' | 'profileAttribute') {
    return data.map((item: any) => {
      var label = item['title'] || item['name'];
      let id = type === 'section' ? `${item.id}-section` : item.id;
      var options = new TreeselectModel(id, label);
      if(type === 'section')
      options.children = null;
      return options;
    });
  }
  public async loadOptions({
    action,
    parentNode,
    callback,
    instanceId,
    searchQuery
  }: TreeselectMethodParams) {
    switch (action) {
      case LOAD_ROOT_OPTIONS:
        await this.loadRootOptions(callback);
        break;
      case LOAD_CHILDREN_OPTIONS:
        await this.loadRootChildrenOptions(parentNode, callback);
        break;
      case ASYNC_SEARCH:
        await this.asyncSearch(searchQuery, callback);
        break;
    }
  }

  public async loadRootOptions(callback: Function) {
    try {
      this.data = await this.client.getAsync(
        this.model.action,
        this.queryParams
      );
      if (this.data && this.data.length > 0)
        this.options = this.getOptions(this.data);
      else this.options = null;
      callback();
    } catch (error) {
      this.data = [];
      callback(new Error(this.model.noChildrenText));
    }
  }

  public async loadRootChildrenOptions(
    parent: TreeselectModel,
    callback: Function
  ) {
    try {
        let id = parent.id.replace('-section','');
        var section = this.data.find(x=> x.id.toString() == id) as Section;
        if(!section){
          section = this.childData.find(x=> x.id.toString() == id) as Section;
        }
        var data = [];
        let type:'section' | 'profileAttribute' ='section'
        if(section.isParent){
        data = this.childData = (await this.client.getAsync(String(),this.queryChildParam(id,type))) as Section[];
        }else{
          type ='profileAttribute'
          data = (await this.childClient.getAsync(String(),this.queryChildParam(id, type))) as ProfileAttribute[];
        }
      if (data && data.length > 0) parent.children = this.getChildOptions(data,type);
      else parent.children = [];

      callback();
    } catch (error) {
      callback(new Error(this.model.noChildrenText));
    }
  }
  public async asyncSearch(searchQuery: string | null, callback: Function) {
    try {
      this.data = await this.client.getAsync(
        this.model.action,
        this.queryParams
      );
      if (this.data && this.data.length > 0)
        callback(null, this.getOptions(this.data));
      else callback(null, null);
    } catch (error) {
      this.data = [];
      callback(new Error(this.model.noChildrenText));
    }
  }

  
  public open(instanceId: string) {
    this.$emit("open", instanceId);
  }
  public close(
    value: number | number[] | TreeselectModel | TreeselectModel[],
    instanceId: string
  ) {
    this.$emit("close", value, this.data, this.options, instanceId);
  }
  public input(
    value: number | number[] | TreeselectModel | TreeselectModel[],
    instanceId: string
  ) {
    this.$emit("input", value, this.data, this.options, instanceId);
  }
  public select(value: TreeselectModel, instanceId: string) {
    this.$emit("select", value, this.data, this.options, instanceId);
  }
  public deselect(value: TreeselectModel, instanceId: string) {
    this.$emit("deselect", value, this.data, this.options, instanceId);
  }
  public searchChange(query: string, instanceId: string) {
    this.$emit("searchChange", query, this.data, this.options, instanceId);
  }

  get queryParams(): ApiQueryOption {
    let where = this.model.whereParams || String();
    if(where)
    where+= `parentSectionId=null`
    else
    where= `parentSectionId=null`
    let instace = new ApiQueryOption(undefined, where);
    instace.orderby = 'id';
    return instace;
  }

  queryChildParam(parentId: string, type:'section' | 'profileAttribute'): ApiQueryOption {

    let where = type === 'section' ? `parentSectionId=${parentId}`: `sectionId=${parentId}`;
    let whereChild = this.model.whereChildrenParams;
    if (whereChild) where += `${whereChild}`;
    let instace = new ApiQueryOption(undefined, where);
    instace.orderby = 'id';
    return instace;
  }
}
